import styled from 'styled-components';
import { Collapse } from 'antd';
import {
  AA_SURFACE,
  AA_TEXT_PRIMARY_ON_LIGHT,
} from '~/modules/Helper/contrast.helper';

const Accordion = styled(Collapse)`
  div.ant-collapse-content,
  div.ant-collapse-content > .ant-collapse-content-box {
    background-color: ${AA_SURFACE} !important;
  }
  div.ant-collapse-header {
    font-size: ${({ theme }) => `${14 + 2 * theme.zoomFonte}px`};
    color: ${AA_TEXT_PRIMARY_ON_LIGHT} !important;
  }
  .ant-collapse-arrow {
    color: ${AA_TEXT_PRIMARY_ON_LIGHT} !important;
  }
`;

export default Accordion;
